<div [formGroup]="form" class="make-responsive">
    <!-- <div class="mt-top-2">Identity Details</div> -->
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName">
            <ng-container *ngIf="submitted && nameFormValues['firstName'].errors">
                <mat-error *ngIf="nameFormValues['firstName'].errors?.['required']">
                    <em
                     class="fas fa-exclamation-circle mr-2"></em>First name is required
                </mat-error>
                <mat-error *ngIf="nameFormValues['firstName'].errors?.['pattern']">
                    <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                    </mat-error>
             </ng-container>
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Middle Name</mat-label>
            <input matInput formControlName="middleName">
            <ng-container *ngIf="submitted && nameFormValues['middleName'].errors">
                <mat-error *ngIf="nameFormValues['middleName'].errors?.['required']">
                    <em
                     class="fas fa-exclamation-circle mr-2"></em>Middle name is required
                </mat-error>
             </ng-container>
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName">
            <ng-container *ngIf="submitted && nameFormValues['lastName'].errors">
                <mat-error *ngIf="nameFormValues['lastName'].errors?.['required']">
                    <em
                     class="fas fa-exclamation-circle mr-2"></em>Last name is required
                </mat-error>
                <mat-error *ngIf="nameFormValues['lastName'].errors?.['pattern']">
                    <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                    </mat-error>
             </ng-container>
        </mat-form-field>
    </div>
</div>